import React, { FC } from "react";
import { Typography } from "../../../Fundamentals/Typography";

export interface INoSearchResultsProps {
  classes?: {
    root?: string;
  };
}

const NoSearchResults: FC<INoSearchResultsProps> = ({ classes }) => {
  return (
    <div className={`${classes?.root || ""}`} data-testid="NoSearchResults">
      <Typography variant="h3-pdp" as="div" classes={{ root: "mb-6" }}>
        Sorry, no results found
      </Typography>
      <Typography as="div" classes={{ root: "mb-6" }}>
        You can try again using a different spelling or browse the categories
        below.
      </Typography>
    </div>
  );
};

export default NoSearchResults;
